import parameters from '@atlassian/jira-relay/src/__generated__/mainJiraBoardFetchCommitDetailsForIssueQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const commitDetailsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-commit-details-popup" */ './src/ui/commit-details-popup-view/main.tsx'
			),
	),
	getPreloadProps: ({ issueId }: { issueId: string }) => ({
		queries: {
			commitDetailsForIssue: {
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				parameters,
				variables: {
					issueId,
				},
			},
		},
	}),
});
